import { Modal as _Modal, styled, Typography } from '@mui/material'
import { CSVLink as _CSVLink } from 'react-csv'

export const CSVLink = styled(_CSVLink)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
}))

export const IDText = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.grey[500],
})) as typeof Typography

export const Modal = styled(_Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))
